export function arrays_equal(a, b) {
  a.sort();
  b.sort();
  return !!a && !!b && !(a < b || b < a);
}
